import { render, staticRenderFns } from "./fiat_withdrawal.vue?vue&type=template&id=ac645c4c&scoped=true"
import script from "./fiat_withdrawal.vue?vue&type=script&lang=js"
export * from "./fiat_withdrawal.vue?vue&type=script&lang=js"
import style0 from "./fiat_withdrawal.vue?vue&type=style&index=0&id=ac645c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac645c4c",
  null
  
)

export default component.exports